import React from 'react';

import {svgIconWrapper} from '../icon/svg-icon-wrapper';

import Office365Logo from './office-365.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Office365Logo {...validProps} />;
}
SvgComponent.iconName = 'office365-logo';

export const Office365LogoIcon = svgIconWrapper(SvgComponent);
